
// Load vue components pre reqs
import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

import zhHant from "vuetify/es5/locale/zh-Hant";
import SocialSharing from "vue-social-sharing";
import VueSimpleSVG from "vue-simple-svg";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import defaultTheme from "@/plugins/themes";

// disable listClick warning because v-list-group is used wrongly
Vue.config.silent = true;

Vue.component("simple-svg", VueSimpleSVG);
Vue.use(SocialSharing);
Vue.use(Vuetify, {
  iconfont: "md",
  options: {
    customProperties: true,
  },
  theme: defaultTheme,
  lang: {
    locales: { zhHant },
    current: "en",
  },
});